export default "__VITE_ASSET__DSoXGs1n__"